// extracted by mini-css-extract-plugin
export var mainHolder = "Layout-module--mainHolder--3Jj1h";
export var headerHolder = "Layout-module--headerHolder--2ane_";